import { useEffect, useState } from "react";
import CommandHeader from "@/components/nessa/CommandHeader";
import HeroDeck from "@/components/nessa/HeroDeck";
import RevenueDashboard from "@/components/nessa/RevenueDashboard";
import DigitalVault from "@/components/nessa/DigitalVault";
import AuthenticatedVault from "@/components/nessa/AuthenticatedVault";
import AffiliateArmor from "@/components/nessa/AffiliateArmor";
import FleetAlliance from "@/components/nessa/FleetAlliance";
import CommandFooter from "@/components/nessa/CommandFooter";
import SecurityBanner from "@/components/nessa/SecurityBanner";

export default function CommandDeck() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  return (
    <div
      className="min-h-screen text-foreground obsidian-grid grain"
      data-testid="command-deck-root"
    >
      <CommandHeader />
      <main className="max-w-6xl mx-auto px-5 sm:px-8 pt-28 pb-20 space-y-20">
        <HeroDeck animate={mounted} />
        <SecurityBanner />
        <RevenueDashboard />
        <DigitalVault />
        <AuthenticatedVault />
        <AffiliateArmor />
        <FleetAlliance />
      </main>
      <CommandFooter />
    </div>
  );
}
